<template>
  <workflow-container ref="container" />
</template>

<script>
import { toolkitMixin } from '@/app/mixins/toolkit/item';
import { pensionSetupMixin } from '@/app/mixins/toolkit/pension/setup';
import WorkflowContainer from '@/app/modules/toolkit/pension/establishment/modules/workflow/containers/workflow-container.vue';

export default {
  name: 'establishment-item',
  mixins: [toolkitMixin, pensionSetupMixin],
  props: {
    uuid: {
      type: String,
      required: false,
    },
  },
  components: {
    WorkflowContainer,
  },
  async mounted() {
    if (this.$route.params.step) {
      this.$refs.container.handleStepChange(parseInt(this.$route.params.step, 10));
      if (this.$route.params.step === 2) {
        const setup = {
          ...this.getItem.setup,
          accumulationKnown: 'Yes',
          taxComponentKnown: 'Yes',
          transferBalanceCapKnown: 'Yes',
        };

        await this.setPartValue(setup);
        await this.setPensionStatus('NEEDS_REVIEW');
        // eslint-disable-next-line no-unused-vars
        await this.$store.dispatch('toolkit/saveItem').catch((err) => {});
      }
    }
  },
};
</script>

<style>

</style>
